import React from 'react';
import TopicIntroContent from '../../components/TopicIntroContent';
import titleIcon from '../../../../../../assets/sme/sso/title_icon.png';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '1';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();

  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);

  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <TopicIntroContent
          title={paragraphsSettings.header}
          icon={titleIcon}
          description={paragraphsSettings.description}
          landingVideo={paragraphsSettings?.landingVideo}
          transcripts={paragraphsSettings.transcripts}
          videoId="videoSso"
        />
      </div>
    </div>
  );
};

export default Section0;
